import { Box, withTheme } from '@material-ui/core';
import styled from 'styled-components';

export default withTheme(styled(Box)`
  padding: 8px;
  border: 1px solid ${({ theme: { palette } }) => palette.secondary.main};
`);
